import { configureStore } from "@reduxjs/toolkit";
import { historyEnhancer } from "./reducers/historyEnhancer.js";
import { rootReducer } from "./reducers/rootReducer.js";
import { sourcesMiddleware } from "./middlewares/sourcesMiddleware.js";
import { get } from "es-toolkit/compat";
export const store = configureStore({
    reducer: historyEnhancer(rootReducer),
    devTools: {
        name: `Mapka Style Editor - ${get(import.meta.env, "VITE_DEPLOY_ENV", "local")}`,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
    }).prepend(sourcesMiddleware),
});
